import { render, staticRenderFns } from "./BillOfMaterials.vue?vue&type=template&id=0b92d1fc&"
import script from "./BillOfMaterials.vue?vue&type=script&lang=js&"
export * from "./BillOfMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports